module.exports = __webpack_public_path__ + "static/media/data.80972e74.svg";